import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, firstValueFrom, of } from 'rxjs';

import { ORDER_SERVER_URL } from '../../config';
import { UsageEvent } from '../models/usage-event';

import { AnalyticsService } from './analytics.service';

const ORDER_N4SDATA_URL = `${ ORDER_SERVER_URL }/v1/n4sdata`;

@Injectable({ providedIn: 'root' })
export class UsageAnalytics {
	constructor(
		private readonly http: HttpClient,
		readonly analyticsService: AnalyticsService,
	) {}

	async sendUsageAnalyticsEvent(
		usageEvent: UsageEvent
	) {
		const url = new URL(ORDER_N4SDATA_URL);
		const data = this.encodeData(usageEvent);
		const body = new URLSearchParams();
		body.set('data', data.toString());

		await firstValueFrom(this.http.post<UsageEvent>(
			url.toString(),
			body,
			{
				headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
			}
		).pipe(catchError((err: unknown) => {
			console.error('unable to send data', err);
			return of(undefined);
		})));
	}

	encodeData(usageEvent: UsageEvent) {
		return btoa(decodeURIComponent(
			encodeURIComponent(JSON.stringify(usageEvent))
		)).split('').reverse().join('');
	}
}
